import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import camelcaseKeys from 'camelcase-keys';
import { useMemo } from 'react';
import { PSearchSlideListItem } from '@/components/modules/pages/proffitSearch/List/PSearchSlideListItem';
import { stringifyUrl } from '@/utils/libs/query-string/stringify';
import { consultantSearchPSearchPath } from '@/utils/router/links';
/**
 * スライドを単体表示するためのラッパーコンポーネント
 * （リンクを制御するためのラッパーコンポーネントなので、デザイン確認はPSearchSlideListItemで行ってください）
 * @constructor
 */
export const CSearchSlideListItem = (props) => {
    const { className, slide: propSlide, slides: propSlides } = props;
    const { slide, to } = useMemo(() => {
        // TODO: PROFFIT SEARCH側とコンサルサーチ側でキャメル/スネークが混在するため、差異を吸収処理を記述しています。後で消す
        const camelCasedSlide = (argsSlide) => ('slideSearchSlideUuid' in argsSlide
            ? argsSlide
            : camelcaseKeys(argsSlide));
        // 詳細ページで関連スライド表示を制御するための値（スライドIDとページIDのペア配列）
        const otherPages = [
            ...new Map(propSlides.map((otherSlide) => [
                camelCasedSlide(otherSlide).slideSearchSlideUuid,
                otherSlide,
            ])).values(),
        ].map((otherSlide) => ({
            pageId: propSlide.page.id,
            slideId: camelCasedSlide(otherSlide).slideSearchSlideUuid,
        }));
        return {
            // キャメルケース化したスライド情報
            slide: camelCasedSlide(propSlide),
            // スライド位置を判定するためのURL
            to: stringifyUrl({
                query: otherPages.length > 0 ? { view: JSON.stringify(otherPages) } : {},
                url: consultantSearchPSearchPath(camelCasedSlide(propSlide).slideSearchSlideUuid),
            }),
        };
    }, [propSlides, propSlide]);
    return (_jsx(PSearchSlideListItem, { className: className, image: slide.page.image, isVertical: slide.page.isVerticalImage, title: slide.title, to: to }));
};
